import { UserStatus } from "@/generated-api";
import { useGetUserProfile, useUserActivity } from "@/tanstack-hooks";
import { useIdleTimer } from "react-idle-timer";

export function ActivityTracker() {
  const { mutate: logActivity } = useUserActivity();
  const getUserProfileQuery = useGetUserProfile();
  const userProfile = getUserProfileQuery.data;
  const isUserActive =
    userProfile?.status === UserStatus.ACTIVE ||
    userProfile?.status === UserStatus.ACTIVE_HIDDEN;

  useIdleTimer({
    timeout: 1000 * 60 * 5, // 5 minutes until considered idle
    throttle: 1000 * 60, // Call API every 1 minutes of activity
    onAction: () => {
      if (isUserActive) {
        logActivity({});
      }
    },
  });

  return null;
}
